import React, { createContext, useContext, useMemo } from 'react';

interface OrderFormContextProps {
  currentPage: number;
  totalPages: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  isShipperEnabled: boolean;
  startPoint?: string;
}

const OrderFormContext = createContext<OrderFormContextProps | null>(null);

export const useOrderFormContext = () => {
  const context = useContext(OrderFormContext);
  if (!context) {
    throw new Error('useOrderFormContext must be used within OrderFormProvider');
  }
  // Calculate variant based on currentPage
  const variant: 'form' | 'summary' = context.currentPage === 5 ? 'summary' : 'form';
  return { ...context, variant };
};

export const OrderFormProvider: React.FC<{
  currentPage: number;
  totalPages: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  isShipperEnabled: boolean;
  startPoint?: string;
  children: React.ReactNode;
}> = ({ currentPage, totalPages, setCurrentPage, isShipperEnabled, startPoint, children }) => {

  const value = useMemo(() => ({
    currentPage,
    totalPages,
    setCurrentPage,
    isShipperEnabled,
    startPoint,
  }), [currentPage, totalPages, setCurrentPage, isShipperEnabled, startPoint]);

  return (
    <OrderFormContext.Provider value={value}>
      {children}
    </OrderFormContext.Provider>
  );
};